export enum EnrollmentTypeIdEnum {
  DRDP2015 = 1,
  DRDP2015Dual = 2,
  FieldStudy = 3,
  EarlyAdopter = 4,
  EarlyAdopterDual = 5,
  DRDP2025 = 6,
  DRDP2025Dual = 7
}
